module.exports = __webpack_public_path__ + "static/media/poster_Ranger2020.10d55112.png";